<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Nombre"
            label-for="nombre"
            :label-cols="labelCols"
            description="Nombre Comercial o Razón Social"
            horizontal>
            <b-form-input 
              id="nombre" 
              v-model="filtro.nombre" 
              type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Nro. Documento"
            label-for="documentoNumero"
            :label-cols="labelCols"
            description="Código de identificación tributaria (CUIT, RUT, CIF, TIN\EIN, etc)"
            horizontal>
            <b-form-input 
              id="documentoNumero" 
              v-model="filtro.documentoNumero" 
              type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Provincia"
            label-for="provincia"
            :label-cols="labelCols"
            horizontal>
            <b-input-group>
              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="seleccionarProvincia">
                <b-input-group-text>
                  <i :class="{ 'fa fa-search': !filtro.provincia,
                                'fa fa-remove': filtro.provincia  }"></i>
                </b-input-group-text>
              </b-input-group-append>
              <b-form-input 
                id="provincia"
                :value="provinciaNombre"
                readonly
                type="text"/>
            </b-input-group>
          </b-form-group>  

          <b-form-group
            label="Localidad"
            label-for="localidad"
            :label-cols="labelCols"
            horizontal>
            <b-input-group>
              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="seleccionarLocalidad">
                <b-input-group-text>
                  <i :class="{ 'fa fa-search': !filtro.localidad,
                                'fa fa-remove': filtro.localidad  }"></i>
                </b-input-group-text>
              </b-input-group-append>
              <b-form-input 
                id="localidad"
                :value="localidadNombre"
                readonly
                type="text"/>
            </b-input-group>
          </b-form-group>  

          <app-categoria
            label="Categoria"
            :nombre="categoriaNombre"
            :lista="categoriasList"
            :label-cols="labelCols"
            :nullOption="false"
            description="Categoría del proveedor"
            @updated="categoriaActualizada">
          </app-categoria>  

          <app-promedio-min
            label="Promedio (Min)"
            :nombre="promedioEvaluacionesMinNombre"
            :lista="promediosList"
            :label-cols="labelCols"
            :nullOption="false"
            description="Calificación promedio minima"
            @updated="promedioEvaluacionesMinActualizado">
          </app-promedio-min>  

          <app-promedio-max
            label="Promedio (Max)"
            :nombre="promedioEvaluacionesMaxNombre"
            :lista="promediosList"
            :label-cols="labelCols"
            :nullOption="false"
            description="Calificación promedio máxima"
            @updated="promedioEvaluacionesMaxActualizado">
          </app-promedio-max>  

          <b-form-group
            label="Etiqueta/s"
            label-for="etiqueta"
            :label-cols="labelCols"
            description="Lista de etiquetas separadas por coma"
            horizontal>
            <b-form-input 
              id="etiqueta" 
              v-model="filtro.etiqueta" 
              type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label-for="inactivo"
            :label-cols="labelCols">
            <b-form-checkbox 
                id="inactivo"
                v-model="filtro.incluirInactivos"
                value= true
                unchecked-value= false>
                Incluir Inactivos
            </b-form-checkbox>
          </b-form-group>
        </b-form>

      <div class="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="filtrar">Filtrar</b-button>
        <b-button size="sm" variant="primary" class="footer-button" 
          @click.prevent="limpiarFiltro">Limpiar</b-button>
      </div>

      </b-collapse>
    </b-card>

    <b-modal ref="searchProvinciaModal" 
        title="Seleccionar Provincia"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-provincia
        :incluirInactivos="true"
        @provinciaSeleccionada="provinciaSeleccionada">
      </app-search-provincia>  
    </b-modal>

    <b-modal ref="searchLocalidadModal" 
        title="Seleccionar Localidad"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-localidad
        :incluirInactivos="true"
        @localidadSeleccionada="localidadSeleccionada">
      </app-search-localidad>  
    </b-modal>
  </div>
</template>

<script>
import SearchProvincia from '../provincias/SearchList.vue';
import SearchLocalidad from '../localidades/SearchList.vue';
import PromedioMin from '../shared/abmSelect.vue';
import PromedioMax from '../shared/abmSelect.vue';
import Categoria from '../shared/abmSelect.vue';

export default {
  name: 'ProveedoresListFiltro',
  components: {
    appSearchProvincia: SearchProvincia,
    appSearchLocalidad: SearchLocalidad,
    appPromedioMin: PromedioMin,
    appPromedioMax: PromedioMax,
    appCategoria: Categoria
  },
  props: {
    nombre: {
      type: String,
      default: ''
    },
    documentoNumero: {
      type: String,
      default: ''
    },
    provincia: {
      type: Object,
      default: null
    },
    localidad: {
      type: Object,
      default: null
    },
    promedioEvaluacionesMin: {
      type: Number,
      default: 0
    },
    promedioEvaluacionesMax: {
      type: Number,
      default: 0
    },
    etiqueta: {
      type: String,
      default: ''
    },
    categoria: {
      type: String,
      default: ''
    },
    incluirInactivos: {
      type: Boolean,
      default: Boolean(false)
    },
    labelCols: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      filtro: {
        nombre: '',
        documentoNumero: '',
        provincia: null,
        localidad: null,
        promedioEvaluacionesMin: 0,
        promedioEvaluacionesMax: 0,
        etiqueta: '',
        categoria: '',
        incluirInactivos: Boolean(false),
      },
      promediosList: [ 'Todos los promedios', '1', '2', '3', '4', '5'],
      categoriasList: [ 'Todas las categorias', 'A', 'B', 'C'],
      showOpcionesFiltro: Boolean(false)
    }
  },
  created() {
      this.filtro.nombre = this.nombre;
      this.filtro.documentoNumero = this.documentoNumero;
      this.filtro.provincia = this.provincia;
      this.filtro.localidad = this.localidad;
      this.filtro.promedioEvaluacionesMin = this.promedioEvaluacionesMin;
      this.filtro.promedioEvaluacionesMax = this.promedioEvaluacionesMax;
      this.filtro.etiqueta = this.etiqueta;
      this.filtro.categoria = this.categoria;
      this.filtro.incluirInactivos = this.incluirInactivos;
  },
  computed: {
    'provinciaNombre': function() {
      return this.filtro.provincia? this.filtro.provincia.nombre.trim() : null;
    },
    'localidadNombre': function() {
      return this.filtro.localidad? this.filtro.localidad.nombre.trim() : null;
    },
    'promedioEvaluacionesMinNombre': function() {
      if (this.filtro.promedioEvaluacionesMin == 0) {
        return 'Todos los promedios';
      }
      return this.filtro.promedioEvaluacionesMin.toString().trim();
    },
    'promedioEvaluacionesMaxNombre': function() {
      if (this.filtro.promedioEvaluacionesMax == 0) {
        return 'Todos los promedios';
      }
      return this.filtro.promedioEvaluacionesMax.toString().trim();
    },
    'categoriaNombre': function() {
      if (this.filtro.categoria == '') {
        return 'Todas las categorias';
      }
      return this.filtro.categoria.toUpperCase().trim();
    },
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.nombre = '';
      this.filtro.documentoNumero = '';
      this.filtro.provincia = null;
      this.filtro.localidad = null;
      this.filtro.promedioEvaluacionesMin = 0;
      this.filtro.promedioEvaluacionesMax = 0;
      this.filtro.etiqueta = '';
      this.filtro.categoria = '';
      this.filtro.incluirInactivos = Boolean(false);
    },
    seleccionarProvincia() {
      if (this.filtro.provincia) {
        this.filtro.provincia = null;
      } else {
        this.$refs.searchProvinciaModal.show();
      }
    },
    provinciaSeleccionada(provincia) {
      this.filtro.provincia = provincia;
      this.$refs.searchProvinciaModal.hide();
    },
    seleccionarLocalidad() {
      if (this.filtro.localidad) {
        this.filtro.localidad = null;
      } else {
        this.$refs.searchLocalidadModal.show();
      }
    },
    localidadSeleccionada(localidad) {
      this.filtro.localidad = localidad;
      this.$refs.searchLocalidadModal.hide();
    },
    promedioEvaluacionesMinActualizado(nombre) {
      if (isNaN(nombre)) {
        this.filtro.promedioEvaluacionesMin = 0;
      } else {
        this.filtro.promedioEvaluacionesMin = parseInt(nombre);
      }
    },
    promedioEvaluacionesMaxActualizado(nombre) {
      if (isNaN(nombre)) {
        this.filtro.promedioEvaluacionesMax = 0;
      } else {
        this.filtro.promedioEvaluacionesMax = parseInt(nombre);
      }
    },
    categoriaActualizada(nombre) {
      this.filtro.categoria = '';

      if (nombre) {
        switch (nombre.toUpperCase().trim()) {
          case "A":
          case "B":
          case "C":  
            this.filtro.categoria = nombre.toUpperCase().trim()    
            break;
        
          default:
            this.filtro.categoria = '';
            break;
        }
      }
    }
  },
}
</script>

<style>
</style>
